import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=3b213326&"
import script from "./CategoryField.vue?vue&type=script&lang=js&"
export * from "./CategoryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b213326')) {
      api.createRecord('3b213326', component.options)
    } else {
      api.reload('3b213326', component.options)
    }
    module.hot.accept("./CategoryField.vue?vue&type=template&id=3b213326&", function () {
      api.rerender('3b213326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/CategoryField.vue"
export default component.exports